import React, { useState, useRef, useEffect } from "react";
// import "../../styles/components/_timer.scss";
// import "../../styles/pages/interview/_question-detail.scss";

export default function Timer({ isRunning }) {
    const [currentTime, setCurrentTime] = useState(0);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (isRunning) {
            intervalRef.current = setInterval(() => {
                setCurrentTime((prevTime) => prevTime + 1000);
            }, 1000);
        } else {
            clearInterval(intervalRef.current);
        }

        return () => clearInterval(intervalRef.current);
    }, [isRunning]);

    const seconds = Math.floor((currentTime / 1000) % 60)
        .toString()
        .padStart(2, "0");
    const minutes = Math.floor((currentTime / (1000 * 60)) % 60)
        .toString()
        .padStart(2, "0");

    return (
        <div className={`timer ${isRunning && "active"}`}>
            {minutes}:{seconds}
        </div>
    );
}
